module.exports = __webpack_public_path__ + "static/media/arrow.b6420ad7.svg";